import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('managers.lovsManagement.preview'),
    visible: _ctx.visible,
    modal: true,
    class: "lovPreviewDialog kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Message, {
        class: "p-m-4",
        severity: "info",
        closable: false
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.lovsManagement.filterNullValues')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_DataTable, {
        value: _ctx.rows,
        class: "p-datatable-sm kn-table",
        dataKey: "field",
        scrollHeight: "flex",
        scrollable: true,
        scrollDirection: "both",
        lazy: true,
        paginator: true,
        rows: 15,
        totalRecords: _ctx.lazyParams.size,
        responsiveLayout: "stack",
        breakpoint: "960px",
        onPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPage($event))),
        onSort: _ctx.onSort
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              class: "kn-truncated",
              field: col.field,
              header: col.header,
              key: col.field,
              sortable: true,
              style: {"flex-grow":"1","flex-basis":"200px"}
            }, null, 8, ["field", "header"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "totalRecords", "onSort"])
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}